import React from 'react'
import styles from '../../styles/modules/components/SelfServe/selfserve-modal.module.scss';
import Button from '../common/ui-components/input/Button';
import UIModal from '../common/ui-components/surface/UIModal';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import { changeProgress, updateDeviceDetails } from '../../redux/actions/selfserveActions';
import { useDispatch, connect } from 'react-redux'
import AddDeviceDetails from '../common/AddDeviceDetails';
interface ReduxStateProps {
    selfserveReducer: any,
}
interface MainProps {
    deviceDetails:any,
    disableBtn:boolean,
    is_open: boolean,
    setDeviceDetails:any,
    setDisableBtn:any,
    setEnableModal: any,
}

type Props = ReduxStateProps & MainProps;


const AddDeviceModal = (props: Props) => {
    const dispatch:any = useDispatch();
    const close = () => {
        props.setEnableModal(false);
        return false
    }
    const proceed = () => {
        close();
        Object.keys(props.deviceDetails).length && dispatch(
            updateDeviceDetails(props.deviceDetails, true, true))
        dispatch(changeProgress(4));
    }
    const title = "Add device "
    const text = "Enter the details for your device:"
    return (
        <UIModal isOpen={props.is_open} onClick={close} larger={false} boxClass={styles.apply_box}>
            <div className={styles.selfserve_add_device}>
                <h5 className={styles.selfserve_add_device__title}>{title}</h5>
                <div className={styles.selfserve_add_device__text}>
                    <p className={styles.common_heading}>{text}</p>
                </div>
                <div className={styles.add_details_popup}>
                    <AddDeviceDetails
                        props={props}
                        setDisableBtn={props.setDisableBtn}
                        setDeviceDetails={props.setDeviceDetails} 
                    />
                </div>

                <div className={`${commonStyles.button_actions_sticky} ${styles.add_device_buttons}`} data-varient='non-sticky'>
                    <Button
                        onClick={close}
                        text="Cancel"
                        variant="secondary"
                        className={commonStyles.cart_btn}
                        style={{ 'fontSize': '14px' }}
                    />
                    <Button
                        text="Submit"
                        disabled={props.disableBtn}
                        onClick={proceed}
                        className={commonStyles.cart_btn}
                        style={{ 'fontSize': '14px' }}
                    />
                </div>
            </div>
        </UIModal>
    )
}

const mapStateToProps = (state: any) => {
    return {
        selfserveReducer: state.selfserveReducer,
    }
}

export default connect<ReduxStateProps>(mapStateToProps)(AddDeviceModal);
